<template>
  <div class="ended">
    <div class="text-right px-4 pt-3 pb-0">
      <button class="btn btn-primary" @click="homeHandler">Home</button>
    </div>
    <!-- Header -->
    <div class="header mt--5 h-100 d-flex justify-content-center align-items-center">
      <b-container>
        <div class="header-body text-center mb-7">
          <b-row class="justify-content-center">
            <b-col class="px-5">
              <h1 class="display-3 text-im2u font-weight-bold mb-0">Oops! Are you lost?</h1>
              <p class="text-im2u mb-4">The page you requested does not exist.</p>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
  </div>
</template>
<style scoped>
  .header{
    z-index:-1
  }
  .ended{
    height: 100vh;
  }
  .text-im2u{
    color:#252938
  }
</style>
<script>
import { mapActions, mapState } from 'pinia'
import { useAuthStore } from '@/stores/authStore'

export default {
  computed: {
     ...mapState(useAuthStore,['auth_user']),
  },
  methods:{
    homeHandler(){
        this.$router.push('/')
    },
  }
};
</script>
